/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Notice_PrivacyInputs */

const en_seller_notice_privacy = /** @type {(inputs: Seller_Notice_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

const pl_seller_notice_privacy = /** @type {(inputs: Seller_Notice_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatność`)
};

/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Seller_Notice_PrivacyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seller_notice_privacy = /** @type {((inputs?: Seller_Notice_PrivacyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Notice_PrivacyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seller_notice_privacy(inputs)
	return en_seller_notice_privacy(inputs)
});